<div class="card" [formGroup]="formGroup">
  <h5 class="card-header" (click)="isCollapsed = !isCollapsed" [class.collapsed-card]="isCollapsed">
    <span>
      <fa-icon [icon]="icons.rotate" [rotate]="isCollapsed ? 0 : 90"></fa-icon>
      {{ conditionTitle }}
    </span>
    <button type="button" (click)="removeCondition()" class="btn btn-close" title="Remove Condition" *ngIf="canRemove">
      <fa-icon [icon]="icons.remove"></fa-icon>
    </button>
  </h5>
  <div class="card-body" [ngbCollapse]="isCollapsed">
    <div [formGroup]="formGroup">
      <div class="form-row">
        <div class="col-xs-12 col-md-4">
          <div class="form-group">
            <select class="form-control" formControlName="leftOperand" (change)="leftOperandChanged()" [compareWith]="compareLeftOperands" [ngClass]="{ 'is-invalid': formControls.leftOperand.touched && formControls.leftOperand.errors }" placeholder="Select a URI part">
              <option disabled [ngValue]="null">Select a data point</option>
              <option *ngFor="let leftOperand of leftOperands" [ngValue]="leftOperand">{{ leftOperand.name }}</option>
            </select>
            <div *ngIf="formControls.leftOperand.touched  && formControls.leftOperand.errors" class="invalid-feedback">
              <div *ngIf="formControls.leftOperand.errors.required">This field is required</div>
            </div>
          </div>
        </div>
        <!-- Various operators -->
        <div class="col-xs-12 col-md-8">
          <div class="form-group">
            <select class="form-control" formControlName="operator" [ngClass]="{ 'is-invalid': formControls.operator.touched && formControls.operator.errors }">
              <option *ngFor="let operator of operators" [ngValue]="operator">{{ operator.name }}</option>
            </select>
            <div *ngIf="formControls.operator.touched  && formControls.operator.errors" class="invalid-feedback">
              <div *ngIf="formControls.operator.errors.required">Operator is required</div>
            </div>
          </div>
        </div>
        <!-- Right operand, as necessary -->
        <ng-container *ngIf="selectedOperator?.hasRightOperand">
          <div class="col-xs-12 col">
            <div class="form-group">
              <input type="text" class="form-control" formControlName="rightOperand" placeholder="/foobar" [ngClass]="{ 'is-invalid': formControls.rightOperand.touched && formControls.rightOperand.errors }">
              <div *ngIf="formControls.rightOperand.touched  && formControls.rightOperand.errors" class="invalid-feedback">
                <div *ngIf="formControls.rightOperand.errors.required">This field is required</div>
                <div *ngIf="formControls.rightOperand.errors.regex">Invalid RegExp: {{ formControls.rightOperand.errors.regex.reason }}</div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-auto">
            <div class="custom-control custom-checkbox" title="Case Sensitive">
              <input type="checkbox" class="custom-control-input" [attr.id]="'ignoreCase-'+index" formControlName="caseSensitive">
              <label class="custom-control-label" [attr.for]="'ignoreCase-'+index">
                <span class="d-xs-block d-sm-none">Case Sensitive</span>
                <span class="d-none d-xs-none d-sm-block">
                  <fa-icon [icon]="icons.caseSensitive"></fa-icon>
                </span>
              </label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
